import Box from "@mui/material/Box";
import React from "react";
import ScheduleTable from "./ScheduleTable";
import {
  TeamScheduleProvider,
  useTeamScheduleContext,
} from "./TeamScheduleContext";

interface TeamScheduleProps {
  teamId: number;
  seasonId: number;
  isMobile: boolean;
}

const TeamSchedule: React.FC<TeamScheduleProps> = ({
  teamId,
  seasonId,
  isMobile,
}) => {
  return (
    <TeamScheduleProvider teamId={teamId} seasonId={seasonId}>
      <TeamScheduleInner isMobile={isMobile} />
    </TeamScheduleProvider>
  );
};

const TeamScheduleInner: React.FC<{ isMobile: boolean }> = ({ isMobile }) => {
  const { filteredMatches, team, loading, error } =
    useTeamScheduleContext();

  if (loading) return <div>Lade Spielplan...</div>;
  if (error) return <div style={{ color: "red" }}>Fehler: {error}</div>;
  if (!team) return <div>Kein Team gefunden.</div>;


  return (
    <Box sx={{ width: "100%", mx: "auto" }}>
      <ScheduleTable
        matches={filteredMatches}
        isMobile={isMobile}
        showScores={false}
        showViewToggles={true}
        showDownloadButton={true}
        adminView={false}
      />
    </Box>
  );
};

export default TeamSchedule;
